import { render, staticRenderFns } from "./imgY.vue?vue&type=template&id=3799a1a0"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3799a1a0')) {
      api.createRecord('3799a1a0', component.options)
    } else {
      api.reload('3799a1a0', component.options)
    }
    module.hot.accept("./imgY.vue?vue&type=template&id=3799a1a0", function () {
      api.rerender('3799a1a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgY.vue"
export default component.exports